import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { RequiredStar } from "./RequiredStar";
import { Label } from "./Label";
import { jsx as ___EmotionJSX } from "@emotion/core";
const StyledSpan = _styled("span", {
  target: "e1qx9uf20"
})("margin-left:5px;color:", _ref => {
  let {
    theme
  } = _ref;
  return theme.gray.base;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdGFuZGFyZC1maWVsZHMvYXRvbXMvRmllbGRMYWJlbC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTThCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdGFuZGFyZC1maWVsZHMvYXRvbXMvRmllbGRMYWJlbC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFJlcXVpcmVkU3RhciB9IGZyb20gJy4vUmVxdWlyZWRTdGFyJztcbmltcG9ydCB7IExhYmVsIH0gZnJvbSAnLi9MYWJlbCc7XG5cbmNvbnN0IFN0eWxlZFNwYW4gPSBzdHlsZWQuc3BhbmBcbiAgbWFyZ2luLWxlZnQ6IDVweDtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuZ3JheS5iYXNlfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBGaWVsZExhYmVsID0gKHsgaWQsIGlubGluZWxhYmVsLCBsYWJlbCwgcmVxdWlyZWQgfSkgPT4ge1xuICBjb25zdCBzZXR0aW5ncyA9IHtcbiAgICBhcHBsaWNhdGlvbl9uYW1lOiAnY29tbW9uX3VpJyxcbiAgICBuYW1lc3BhY2U6ICdjb21tb25fZmllbGRzJyxcbiAgfTtcblxuICAvLyBUaGUgbGFiZWwgc2hvdWxkIHJlYWxseSBiZSByZXF1aXJlZCBidXRcbiAgLy8gaW4gY2FzZSB0aGUgcGFyZW50IGNvbXBvbmVudCBkb2Vzbid0IGhhdmUgYSBsYWJlbCBwcm9wIGp1c3QgcmV0dXJuIG51bGxcblxuICBpZiAoIWxhYmVsKSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxMYWJlbCBpbmxpbmVsYWJlbD17aW5saW5lbGFiZWx9IGh0bWxGb3I9e2lkfT5cbiAgICAgIHtyZXF1aXJlZCAmJiA8UmVxdWlyZWRTdGFyIC8+fVxuICAgICAge2Ake2xhYmVsfTpgfVxuICAgICAgeyFyZXF1aXJlZCAmJiAoXG4gICAgICA8U3R5bGVkU3Bhbj5cbiAgICAgICAgKFxuICAgICAgICB7X18oJ09wdGlvbmFsJywgW10sIHNldHRpbmdzKX1cbiAgICAgICAgKVxuICAgICAgPC9TdHlsZWRTcGFuPlxuICAgICAgKX1cbiAgICA8L0xhYmVsPlxuICApO1xufTtcblxuRmllbGRMYWJlbC5kZWZhdWx0UHJvcHMgPSB7XG4gIGlubGluZWxhYmVsOiBmYWxzZSxcbn07XG5cbkZpZWxkTGFiZWwucHJvcFR5cGVzID0ge1xuICBpZDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBpbmxpbmVsYWJlbDogUHJvcFR5cGVzLmJvb2wsXG4gIGxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxuICByZXF1aXJlZDogUHJvcFR5cGVzLmJvb2wsXG4gIC8vIHNob3dDb2xvbjogUHJvcFR5cGVzLmJvb2wsXG59O1xuIl19 */"));
export const FieldLabel = _ref2 => {
  let {
    id,
    inlinelabel,
    label,
    required
  } = _ref2;
  const settings = {
    application_name: 'common_ui',
    namespace: 'common_fields'
  };

  // The label should really be required but
  // in case the parent component doesn't have a label prop just return null

  if (!label) {
    return null;
  }
  return ___EmotionJSX(Label, {
    inlinelabel: inlinelabel,
    htmlFor: id
  }, required && ___EmotionJSX(RequiredStar, null), `${label}:`, !required && ___EmotionJSX(StyledSpan, null, "(", __('Optional', [], settings), ")"));
};
FieldLabel.defaultProps = {
  inlinelabel: false
};
FieldLabel.propTypes = {
  id: PropTypes.string.isRequired,
  inlinelabel: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool
  // showColon: PropTypes.bool,
};